import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Checkbox } from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import './style.scss';
import Helpers from '@Apis/helpers';
/**
 *
 */
const SyncData = ({
  pullTallyVendors, pullTallyProducts, pullTallyVendorsLoading,
  pullTallyProductsLoading, tallyConnections, user, setStep,
  stepNumber, pullTallyCustomers,
}) => {
  useEffect(() => {
  }, []);

  const [pullProductsData, setPullProductsData] = useState(false);
  const [pullVendorsData, setPullVendorsData] = useState(false);
  const [pullCustomersData, setPullCustomersData] = useState(false);

  const integrationTallyIdURL = Number(Helpers.getValueFromUrl('it_id'));
  const handleSubmit = () => {
    const payload2 = {
      org_id: user?.tenant_info?.org_id,
      it_id: integrationTallyIdURL,
    };
    if (pullVendorsData) {
      pullTallyVendors(payload2, () => {
        if (pullProductsData && pullCustomersData) {
          pullTallyProducts(payload2, () => {
            pullTallyCustomers(payload2, () => {
              setStep(stepNumber + 1);
            });
          });
        } else if (pullProductsData) {
          pullTallyProducts(payload2, () => {
            setStep(stepNumber + 1);
          });
        } else if (pullCustomersData) {
          pullTallyCustomers(payload2, () => {
            setStep(stepNumber + 1);
          });
        } else {
          setStep(stepNumber + 1);
        }
      });
    } else if (pullProductsData) {
      pullTallyProducts(payload2, () => {
        if (pullVendorsData && pullCustomersData) {
          pullTallyVendors(payload2, () => {
            pullTallyCustomers(payload2, () => {
              setStep(stepNumber + 1);
            });
          });
        } else if (pullVendorsData) {
          pullTallyVendors(payload2, () => {
            setStep(stepNumber + 1);
          });
        } else if (pullCustomersData) {
          pullTallyCustomers(payload2, () => {
            setStep(stepNumber + 1);
          });
        } else {
          setStep(stepNumber + 1);
        }
      });
    } else if (pullCustomersData) {
      pullTallyCustomers(payload2, () => {
        if (pullProductsData && pullVendorsData) {
          pullTallyVendors(payload2, () => {
            pullTallyProducts(payload2, () => {
              setStep(stepNumber + 1);
            });
          });
        } else if (pullVendorsData) {
          pullTallyVendors(payload2, () => {
            setStep(stepNumber + 1);
          });
        } else if (pullProductsData) {
          pullTallyProducts(payload2, () => {
            setStep(stepNumber + 1);
          });
        } else {
          setStep(stepNumber + 1);
        }
      });
    } else {
      setStep(stepNumber + 1);
    }
  };

  return (
    <Fragment>
      <div className="integration-step__wrapper">
        <div style={{ fontSize: '14px', marginBottom: '5px', marginTop: '10px' }}>
          Pull vendor master, customers and items master data from Tally
        </div>
        <div style={{ marginTop: '10px', fontWeight: '400', fontSize: '12px' }}>
          <Checkbox
            checked={pullProductsData}
            onChange={(e) => {
              setPullProductsData(e.target.checked);
            }}
          >
            Sync Products
          </Checkbox>
        </div>
        <div style={{ marginTop: '10px', fontWeight: '400', fontSize: '12px' }}>
          <Checkbox
            checked={pullVendorsData}
            onChange={(e) => {
              setPullVendorsData(e.target.checked);
            }}
          >
            Sync Vendors
          </Checkbox>
        </div>
        <div style={{ marginTop: '10px', fontWeight: '400', fontSize: '12px' }}>
          <Checkbox
            checked={pullCustomersData}
            onChange={(e) => {
              setPullCustomersData(e.target.checked);
            }}
          >
            Sync Customers
          </Checkbox>
        </div>
      </div>
      <div className="integration-step__footer" style={{ display: 'flex', paddingTop: '10px', paddingLeft: '15px' }}>
        <Button
          type="primary"
          ghost
          onClick={() => setStep(stepNumber - 1)}
          disabled={pullTallyVendorsLoading || pullTallyProductsLoading}
        >
          Back
        </Button>
        &nbsp;&nbsp;
        <Button
          type="primary"
          onClick={() => handleSubmit()}
          disabled={pullTallyVendorsLoading || pullTallyProductsLoading}
        >
          Save and Continue
        </Button>
      </div>

    </Fragment>
  );
};

const mapStateToProps = ({ /* Import Reducers here */ UserReducers, TallyIntegrationReducers }) => ({
  user: UserReducers.user,
  pullTallyProductsLoading: TallyIntegrationReducers.pullTallyProductsLoading,
  pullTallyVendorsLoading: TallyIntegrationReducers.pullTallyVendorsLoading,
  pullTallyCustomersLoading: TallyIntegrationReducers.pullTallyCustomersLoading,
  tallyConnections: TallyIntegrationReducers.tallyConnections,

});

const mapDispatchToProps = (/* Import actions here */ dispatch) => ({
  pullTallyProducts: (payload, callback) => dispatch(TallyIntegrationActions.pullTallyProducts(payload, callback)),
  pullTallyVendors: (payload, callback) => dispatch(TallyIntegrationActions.pullTallyVendors(payload, callback)),
  pullTallyCustomers: (payload, callback) => dispatch(TallyIntegrationActions.pullTallyCustomers(payload, callback)),

});

SyncData.propTypes = {
  user: PropTypes.any,
  pullTallyVendors: PropTypes.func,
  pullTallyProducts: PropTypes.func,
  pullTallyVendorsLoading: PropTypes.bool,
  pullTallyProductsLoading: PropTypes.bool,
  tallyConnections: PropTypes.any,
  setStep: PropTypes.func,
  stepNumber: PropTypes.any,
  pullTallyCustomers: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SyncData));
